import { bootstrapApplication } from '@angular/platform-browser';
import { addIcons } from 'ionicons';
import {
  logoIonic,
  homeOutline,
  tvOutline,
  listOutline,
  documentOutline,
  documentTextOutline,
  logOutOutline,
  createOutline,
  checkmarkOutline,
  closeOutline,
  wifi,
  pulse,
  addOutline,
  eyeOutline,
  copyOutline,
  trashOutline,
  chevronForward,
  chevronForwardOutline,
  codeSlashOutline,
  addCircleOutline,
  newspaperOutline,
  barChartOutline,
  chatbubblesOutline,
  personCircleOutline,
  peopleOutline,
  starOutline,
  mailOutline,
  searchOutline,
  personAddOutline,
  layersOutline,
  desktopOutline,
  chevronExpandOutline,
  cloudOutline,
  informationCircleOutline,
  imageOutline,
  imagesOutline,
  alertCircleOutline,
  personOutline,
  businessOutline,
  shieldCheckmarkOutline,
  chevronDownOutline,
  heartOutline,
  locationOutline,
  lockClosedOutline,
  gridOutline,
  globeOutline,
  wifiOutline,
  musicalNotesOutline,
  arrowForwardOutline,
  arrowBackOutline,
  reorderTwoOutline,
  checkmark,
  timeOutline,
  pulseOutline,
  radioButtonOnOutline,
  checkmarkCircle,
  ellipseOutline,
  settingsOutline,
  pencilOutline,
  readerOutline,
  notificationsOutline,
  downloadOutline,
  constructOutline,
  checkmarkCircleOutline,
  tabletLandscapeOutline,
  phonePortraitOutline,
  scanOutline,
  journalOutline,
  busOutline,
  megaphoneOutline,
  reloadOutline,
  moonOutline,
  sunnyOutline,
  chatbubbleEllipsesOutline,
  attachOutline,
  sendOutline,
  closeCircle,
  calendarOutline,
  chevronUpOutline,
  optionsOutline,
  happyOutline,
  syncOutline,
  storefrontOutline,
  cubeOutline,
  hammerOutline,
  cardOutline,
  chatbubbleOutline,
  partlySunnyOutline,
  refreshOutline,
  rocketOutline,
  linkOutline,
  headsetOutline,
  trainOutline,
  flashOutline,
  calculatorOutline,
  shareSocialOutline,
  colorWandOutline,
  swapHorizontalOutline,
  arrowUndoOutline,
  arrowRedoOutline,
  warningOutline,
  textOutline,
  squareOutline,
  arrowUpOutline,
  arrowDownOutline,
  reorderThreeOutline,
  removeOutline,
  lockOpenOutline,
  bookmarkOutline,
  arrowForwardCircleOutline,
  saveOutline,
  hourglassOutline,
  thermometerOutline,
  mapOutline,
  sparklesOutline,
  archiveOutline,
  folderOpenOutline,
  folderOutline,
  checkboxOutline,
  cloudUploadOutline,
  cloudDownloadOutline,
  openOutline,
  closeCircleOutline,
  searchCircleOutline,
  shieldHalfOutline,
  browsersOutline,
  analyticsOutline,
  qrCodeOutline,
  arrowUpCircleOutline,
  arrowDownCircleOutline,
  videocamOutline,
  cameraOutline,
  helpCircleOutline,
  bugOutline,
  removeCircleOutline,
  brushOutline,
  duplicateOutline,
  cutOutline,
  playCircleOutline,
  stopCircleOutline,
  eyeOffOutline,
  restaurantOutline,
  fastFoodOutline,
  cafeOutline,
  wineOutline,
  beerOutline,
  pizzaOutline,
  nutritionOutline,
  iceCreamOutline,
  sadOutline,
  thumbsUpOutline,
  thumbsDownOutline,
  briefcaseOutline,
  cashOutline,
  trophyOutline,
  ribbonOutline,
  giftOutline,
  diamondOutline,
  navigateOutline,
  carOutline,
  bicycleOutline,
  walkOutline,
  filmOutline,
  alarmOutline,
  leafOutline,
  flameOutline,
  keyOutline,
  appsOutline,
  chatbubbles,
  checkmarkDoneOutline,
  helpBuoyOutline,
  peopleCircleOutline,
  ellipsisHorizontal,
} from 'ionicons/icons';


import { appConfig } from './app/app.config';
import { AppComponent } from "./app/app.component";

addIcons({
  logoIonic,
  'home-outline': homeOutline,
  'tv-outline': tvOutline,
  'list-outline': listOutline,
  'document-outline': documentOutline,
  'document-text-outline': documentTextOutline,
  'log-out-outline': logOutOutline,
  'create-outline': createOutline,
  'checkmark-outline': checkmarkOutline,
  'close-outline': closeOutline,
  wifi,
  pulse,
  'add-outline': addOutline,
  'eye-outline': eyeOutline,
  'copy-outline': copyOutline,
  'trash-outline': trashOutline,
  'chevron-forward': chevronForward,
  'chevron-forward-outline': chevronForwardOutline,
  'code-slash-outline': codeSlashOutline,
  'add-circle-outline': addCircleOutline,
  'newspaper-outline': newspaperOutline,
  'bar-chart-outline': barChartOutline,
  'chatbubbles-outline': chatbubblesOutline,
  'person-circle-outline': personCircleOutline,
  'people-outline': peopleOutline,
  'star-outline': starOutline,
  'mail-outline': mailOutline,
  'search-outline': searchOutline,
  'person-add-outline': personAddOutline,
  'layers-outline': layersOutline,
  'chevron-expand-outline': chevronExpandOutline,
  'desktop-outline': desktopOutline,
  'cloud-outline': cloudOutline,
  'journal-outline': journalOutline,
  'bus-outline': busOutline,
  'information-circle-outline': informationCircleOutline,
  'image-outline': imageOutline,
  'images-outline': imagesOutline,
  'alert-circle-outline': alertCircleOutline,
  'person-outline': personOutline,
  'business-outline': businessOutline,
  'shield-checkmark-outline': shieldCheckmarkOutline,
  'chevron-down-outline': chevronDownOutline,
  'location-outline': locationOutline,
  'heart-outline': heartOutline,
  'lock-closed-outline': lockClosedOutline,
  'grid-outline': gridOutline,
  'globe-outline': globeOutline,
  'wifi-outline': wifiOutline,
  'musical-notes-outline': musicalNotesOutline,
  'arrow-back-outline': arrowBackOutline,
  'reorder-two-outline': reorderTwoOutline,
  'checkmark': checkmark,
  'arrow-forward-outline': arrowForwardOutline,
  'time-outline': timeOutline,
  'pulse-outline': pulseOutline,
  'radio-button-on-outline': radioButtonOnOutline,
  'checkmark-circle': checkmarkCircle,
  'ellipse-outline': ellipseOutline,
  'settings-outline': settingsOutline,
  'pencil-outline': pencilOutline,
  'reader-outline': readerOutline,
  'notifications-outline': notificationsOutline,
  'download-outline': downloadOutline,
  'construct-outline': constructOutline,
  'checkmark-circle-outline': checkmarkCircleOutline,
  'tablet-landscape-outline': tabletLandscapeOutline,
  'phone-portrait-outline': phonePortraitOutline,
  'scan-outline': scanOutline,
  'megaphone-outline': megaphoneOutline,
  'reload-outline': reloadOutline,
  'moon-outline': moonOutline,
  'sunny-outline': sunnyOutline,
  'chatbubble-ellipses-outline': chatbubbleEllipsesOutline,
  'attach-outline': attachOutline,
  'send-outline': sendOutline,
  'close-circle': closeCircle,
  'calendar-outline': calendarOutline,
  'chevron-up-outline': chevronUpOutline,
  'options-outline': optionsOutline,
  'happy-outline': happyOutline,
  'sync-outline': syncOutline,
  'storefront-outline': storefrontOutline,
  'cube-outline': cubeOutline,
  'hammer-outline': hammerOutline,
  'card-outline': cardOutline,
  'chatbubble-outline': chatbubbleOutline,
  'partly-sunny-outline': partlySunnyOutline,
  'refresh-outline': refreshOutline,
  'rocket-outline': rocketOutline,
  'link-outline': linkOutline,
  'headset-outline': headsetOutline,
  'train-outline': trainOutline,
  'flash-outline': flashOutline,
  'calculator-outline': calculatorOutline,
  'share-social-outline': shareSocialOutline,
  'color-wand-outline': colorWandOutline,
  'swap-horizontal-outline': swapHorizontalOutline,
  'arrow-undo-outline': arrowUndoOutline,
  'arrow-redo-outline': arrowRedoOutline,
  'warning-outline': warningOutline,
  'text-outline': textOutline,
  'square-outline': squareOutline,
  'arrow-up-outline': arrowUpOutline,
  'arrow-down-outline': arrowDownOutline,
  'reorder-three-outline': reorderThreeOutline,
  'remove-outline': removeOutline,
  'lock-open-outline': lockOpenOutline,
  'bookmark-outline': bookmarkOutline,
  'arrow-forward-circle-outline': arrowForwardCircleOutline,
  'save-outline': saveOutline,
  'hourglass-outline': hourglassOutline,
  'thermometer-outline': thermometerOutline,
  'map-outline': mapOutline,
  'sparkles-outline': sparklesOutline,
  'archive-outline': archiveOutline,
  'folder-open-outline': folderOpenOutline,
  'folder-outline': folderOutline,
  'checkbox-outline': checkboxOutline,
  'cloud-upload-outline': cloudUploadOutline,
  'cloud-download-outline': cloudDownloadOutline,
  'open-outline': openOutline,
  'close-circle-outline': closeCircleOutline,
  'search-circle-outline': searchCircleOutline,
  'shield-half-outline': shieldHalfOutline,
  'browsers-outline': browsersOutline,
  'analytics-outline': analyticsOutline,
  'qr-code-outline': qrCodeOutline,
  'arrow-up-circle-outline': arrowUpCircleOutline,
  'arrow-down-circle-outline': arrowDownCircleOutline,
  'videocam-outline': videocamOutline,
  'camera-outline': cameraOutline,
  'help-circle-outline': helpCircleOutline,
  'bug-outline': bugOutline,
  'remove-circle-outline': removeCircleOutline,
  'brush-outline': brushOutline,
  'duplicate-outline': duplicateOutline,
  'cut-outline': cutOutline,
  'play-circle-outline': playCircleOutline,
  'stop-circle-outline': stopCircleOutline,
  'eye-off-outline': eyeOffOutline,
  'restaurant-outline': restaurantOutline,
  'fast-food-outline': fastFoodOutline,
  'cafe-outline': cafeOutline,
  'wine-outline': wineOutline,
  'beer-outline': beerOutline,
  'pizza-outline': pizzaOutline,
  'nutrition-outline': nutritionOutline,
  'ice-cream-outline': iceCreamOutline,
  'sad-outline': sadOutline,
  'thumbs-up-outline': thumbsUpOutline,
  'thumbs-down-outline': thumbsDownOutline,
  'briefcase-outline': briefcaseOutline,
  'cash-outline': cashOutline,
  'trophy-outline': trophyOutline,
  'ribbon-outline': ribbonOutline,
  'gift-outline': giftOutline,
  'diamond-outline': diamondOutline,
  'navigate-outline': navigateOutline,
  'car-outline': carOutline,
  'bicycle-outline': bicycleOutline,
  'walk-outline': walkOutline,
  'film-outline': filmOutline,
  'alarm-outline': alarmOutline,
  'leaf-outline': leafOutline,
  'flame-outline': flameOutline,
  'key-outline': keyOutline,
  'apps-outline': appsOutline,
  'send': sendOutline,
  'chat-bubbles': chatbubblesOutline,
  'chatbubbles': chatbubbles,
  'checkmark-done-outline': checkmarkDoneOutline,
  'help-buoy-outline': helpBuoyOutline,
  'people-circle-outline': peopleCircleOutline,
  'ellipsis-horizontal': ellipsisHorizontal,
});

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.log(err));
